import {
  House as FiHome,
  List as FiList,
  FileText as FiFileText,
  Person as FiUser,
  Briefcase as FiBriefcase,
  Gear as FiSettings,
  ArrowCounterclockwise as FiReturns,
  ClipboardData as FiClipboard,
  Wallet2 as FiWallet2,
  CreditCard2Front as FiCreditCard,
  CashStack as FiCashStack,
  BagCheck as FiBagCheck,
  Truck as FiTruck,
  Receipt as FiReceipt,
  JournalText as FiQuotes,
  Cart as FiShoppingCart,
} from 'react-bootstrap-icons';

export type MobileNavIcon = React.ComponentType<{
  className?: string;
  size?: number | string;
  style?: React.CSSProperties;
}>;

export const MOBILE_NAV_ICONS: Record<string, MobileNavIcon> = {
  home: FiHome,
  'orders-group': FiFileText,
  orders: FiClipboard,
  quotes: FiQuotes,
  'clients-orders': FiShoppingCart,
  returns: FiReturns,
  inventory: FiList,
  'finance-group': FiCashStack,
  'accounts-receivable': FiWallet2,
  'accounts-payable': FiCreditCard,
  'purchasing-group': FiBagCheck,
  suppliers: FiTruck,
  purchases: FiReceipt,
  clients: FiBriefcase,
  vendors: FiUser,
  configuration: FiSettings,
};
